import { createVanIconComponent } from "./van"

const MoreOutlined = createVanIconComponent("more-o")
export default MoreOutlined
